import styled from 'styled-components'

const Button = styled.button`
    display: flex;
    position: relative;
    height: 44px;
    width: 100%;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    border-radius: ${({ radius }) => radius || '8px'};
    outline: none;
    border: none;
    font-size: ${(props) => props.fontSize || props.theme.fontSize};
    font-weight: ${(props) => props.fontWeight || props.theme.fontWeight};
    font-family: ${(props) => props.theme.fontFamily};
    transition: all 0.3s ease-in-out;
    color: ${(props) =>
        props.color
            ? props.color
            : props.theme.colors.colorTextOnAccentDefault};
    background: ${(props) =>
        props.bgColor
            ? props.bgColor
            : props.theme.colors.colorBackgroundFillAccentDefault};
    border: ${(props) =>
        props.borderColor
            ? '1px solid ' + props.borderColor
            : '1px solid transparent'};
    cursor: pointer;
    justify-content: center;
    align-items: center;
    gap: 8px;

    &:hover {
        color: ${(props) =>
            props.colorHover
                ? props.colorHover
                : props.theme.colors.colorTextOnAccentHover};
        background: ${(props) =>
            props.bgColorHover
                ? props.bgColorHover
                : props.theme.colors.colorBackgroundFillAccentHover};
        cursor: pointer;
    }

    &:disabled {
        color: ${(props) =>
            props.disabledColor
                ? props.disabledColor
                : props.theme.colors.colorTextOnAccentInactive};
        background: ${(props) =>
            props.bgDisabledColor
                ? props.bgDisabledColor
                : props.theme.colors.colorBackgroundFillAccentDisabled};
        cursor: not-allowed;
    }
`
export default Button
